export default __webpack_public_path__ + "static/media/proj10.ee296916.png";